import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from './environments/environment';
import { AppSettings } from "./shared/appSettings";
@Injectable({
  providedIn: 'root'
})
export class AppConst {
  static appConfig: AppSettings;
  static apiUrl: string;
  static securityKey: string;
  static submissionSection: any = {};
  static rootWeb: string;
  static isPassTokenInUrl: boolean;
  static allPermissionOfUser: Array<any> = [];
  static allUserConfiguration: any = {};
  static MaxTIVValidationValue: any;
  static MaxTIVValidationMessage: string = "";
  static effectiveExpDateMsg: string = "";
  static floodWarningMsg: string = "";
  static EmpCountRateMsg: string = "";
  static InlandMarineDefault: Array<any> = [];

  constructor(public http: HttpClient) { }

  loadAppSettings() {
    return this.http.get<AppSettings>("assets/app-setting.json")
      .toPromise()
      .then((response) => {
        AppConst.assignData(response);
      });
  }

  public showItem(permissionName: string): boolean {
    return AppConst.allPermissionOfUser && AppConst.allPermissionOfUser.filter(f => f === permissionName).length > 0;
  }

  static getAuthToken() {
    const token = localStorage.getItem('T' + this.appConfig.environment + this.appConfig.securityKey);
    return token ? JSON.parse(token).AccessToken : null;
  }

  static assignData(data: AppSettings) {
    AppConst.appConfig = data;
    AppConst.apiUrl = environment.production == true ? data.apiBaseUrlProd : data.apiBaseUrl;
    AppConst.securityKey = environment.production == true ? data.environment + data.securityKeyProd : data.environment +data.securityKey;
    AppConst.submissionSection = data.submissionSection;
    AppConst.isPassTokenInUrl = data.IsPassTokenInUrl;
    AppConst.rootWeb = environment.production == true ? data.rootWebProd : data.rootWeb;
    AppConst.effectiveExpDateMsg = data.effectiveExpDateMsg;
    AppConst.floodWarningMsg = data.floodWarningMsg;
    AppConst.MaxTIVValidationValue = data.MaxTIVValidationValue;
    AppConst.MaxTIVValidationMessage = data.MaxTIVValidationMessage;
    AppConst.EmpCountRateMsg = data.EmpCountRateMsg;
    AppConst.InlandMarineDefault = data.InlandMarineDefault;
    }

  }

